import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknownUserAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 45,
	viewBox: "0 0 45 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.4996 30.2765C27.5868 30.2765 31.7254 26.1373 31.7254 21.0501C31.7254 15.9629 27.5868 11.8242 22.4996 11.8242C17.4123 11.8242 13.2737 15.9629 13.2737 21.0501C13.2737 26.1373 17.4123 30.2765 22.4996 30.2765Z",
		fill: "#9C99A8"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.5991 38.4696L7.62048 39.3698C7.62207 39.3709 7.62314 39.373 7.62526 39.3746C11.7373 43.002 17.0201 44.9991 22.5001 44.9991C27.98 44.9991 33.2628 43.0015 37.3749 39.3746C37.377 39.373 37.3781 39.3714 37.3797 39.3698L38.401 38.4696L38.367 38.4398C42.596 34.2278 45.0001 28.4939 45.0001 22.4995C45.0001 10.0931 34.9065 0 22.5001 0C10.0937 0 0 10.0931 0 22.4995C0 28.4939 2.40359 34.2278 6.63311 38.4398L6.5991 38.4696ZM2.41368 22.4995C2.41368 11.4238 11.4243 2.41315 22.5001 2.41315C33.5758 2.41315 42.5865 11.4238 42.5865 22.4995C42.5865 27.9125 40.3928 33.0885 36.5342 36.8599C32.555 33.68 27.6139 31.9391 22.5001 31.9391C17.3863 31.9391 12.4452 33.68 8.46596 36.8599C4.60736 33.0885 2.41368 27.9125 2.41368 22.4995Z",
		fill: "#9C99A8"
	})]
});
export default SvgUnknownUserAvatar;
